import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';

/** One option of a number format: its name, then its choices. */
export const FormatRow = memo(
  ({ label, children }: { label: string; children: ReactNode }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: rpx(6),
        }}
      >
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ width: rpx(56) }}
        >
          {label}
        </Typography.Text>
        {children}
      </View>
    );
  },
);
